import { IdeaDto, SeoMapDto } from "@growth/dto";
import { ContentFormat } from "@growth/schema";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { api } from "./api";

const busy = (map: SeoMapDto | undefined) =>
  Boolean(map?.run && ["queued", "running"].includes(map.run.status)) ||
  Boolean(
    map?.topics.some((topic) =>
      topic.questions.some((question) => question.runStatus === "RUNNING"),
    ),
  );

export const useSeoMap = () =>
  useQuery({
    queryKey: ["seo"],
    queryFn: async () => (await api.get<SeoMapDto>("/seo")).data,
    refetchInterval: (query) => (busy(query.state.data) ? 3000 : false),
  });

export const useRefreshSeo = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async () => (await api.post<SeoMapDto>("/seo/refresh")).data,
    onSuccess: (map) => queryClient.setQueryData(["seo"], map),
  });
};

export const useBriefQuestion = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (id: string) =>
      (await api.post<SeoMapDto>(`/seo/questions/${id}/brief`)).data,
    onSuccess: (map) => queryClient.setQueryData(["seo"], map),
  });
};

export const useSocialFromPost = (postId: string) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (formats: ContentFormat[]) =>
      (
        await api.post<{ idea: IdeaDto; pieceIds: string[] }>(`/posts/${postId}/social`, {
          formats,
        })
      ).data,
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ["pieces"] });
      void queryClient.invalidateQueries({ queryKey: ["ideas"] });
    },
  });
};
